export default __webpack_public_path__ + "locales/sl/About.json?hash=bf49f1363a7571d5a59a340c59849625";